import 'tippy.js/dist/tippy.css'
import './index.scss'
import Tippy from '@tippyjs/react'
import classNames from 'classnames'
import {useSelector} from 'react-redux'

const Tooltip = ({classname, btnClassName, children, placement = 'bottom', content, trigger, interactive, noButton, containerClassname, appendTo = null}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    return (
        content ? <div className={classNames({
            'custom-tooltip': true,
            [classname]: classname,
            dark: isDarkMode
        })}>
            <Tippy content={<span>{content}</span>}
                placement={placement} trigger={trigger} interactive={interactive} className={containerClassname || ''} appendTo={appendTo ?? document.body}>
                {
                    noButton
                        ?
                        <div className="custom-tooltip-button">
                            {children}
                        </div>
                        :
                        <button type="button" className={classNames({
                            'custom-tooltip-button': true,
                            [btnClassName]: btnClassName
                        })}>
                            {children}
                        </button>
                }
            </Tippy>
        </div> : children
    )
}

export default Tooltip
